import { render, staticRenderFns } from "./ViewJobDetail.vue?vue&type=template&id=545c5a92&scoped=true"
import script from "./ViewJobDetail.vue?vue&type=script&lang=js"
export * from "./ViewJobDetail.vue?vue&type=script&lang=js"
import style0 from "./ViewJobDetail.vue?vue&type=style&index=0&id=545c5a92&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545c5a92",
  null
  
)

export default component.exports